import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import '../../css/home.css';
import language from '../../js/stores/language.js';
import user from '../../js/stores/user.js';
import car from '../../js/stores/car.js';
import contact from '../../js/stores/contact.js';
import carLoan from '../../js/stores/car-loan.js';
import carAppointments from '../../js/stores/car-appointment.js';
import carLoanItemLibrary from '../../js/controllers/car-loan-item-lib.js';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var carId = user.getters.carId.value;
  var carLender = [];
  var carBorrower = [];
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var lenderList, borrowerList;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return carLoan.dispatch('getLenderList');
        case 1:
          lenderList = _context.sent;
          if (lenderList.status !== undefined && lenderList.status !== 200) console.log(lenderList.data.messages.error);else carLender = lenderList;
          _context.next = 2;
          return carLoan.dispatch('getBorrowerList');
        case 2:
          borrowerList = _context.sent;
          if (borrowerList.status !== undefined && borrowerList.status !== 200) console.log(borrowerList.data.messages.error);else carBorrower = borrowerList;
          $update();
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var continueToLoan = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var anchor, carLoanId, obj;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            anchor = e.target.closest("a");
            carLoanId = anchor.dataset.carLoanId;
            _context2.next = 1;
            return getData(e);
          case 1:
            obj = _context2.sent;
            $f7.views.main.router.navigate("/loan-item/".concat(carLoanId), obj);
            $update();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function continueToLoan(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
      var obj, anchor, carLoanId, _carId, isOwner, carLoanItem, _t;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            obj = {};
            $f7.preloader.show();
            _context3.prev = 1;
            e.preventDefault();
            anchor = e.target.closest("a");
            carLoanId = anchor.dataset.carLoanId;
            _carId = anchor.dataset.carId;
            isOwner = user.getters.carId.value == _carId ? true : false;
            carLoanItem = isOwner ? carLender.filter(function (item) {
              return item.CarLoanId == carLoanId;
            }) : carBorrower.filter(function (item) {
              return item.CarLoanId == carLoanId;
            });
            _context3.next = 2;
            return carLoanItemLibrary.getLoanData(carLoanId, carLoanItem[0]);
          case 2:
            obj = _context3.sent;
            $f7.preloader.hide();
            _context3.next = 4;
            break;
          case 3:
            _context3.prev = 3;
            _t = _context3["catch"](1);
            $f7.preloader.hide();
            console.error(_t);
          case 4:
            return _context3.abrupt("return", obj);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function getData(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="loan-dashboard">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">${locale.translate('loan.title')}</div>
    </div>
  </div>
  <div class="page-content">
    <div class="center-content" >
      ${carLender.length > 0 && $h`
      <div class="block-title">${locale.translate('loan.lends')}</div>
      <div class="data-table">
        <table>
          <thead>
            <tr>
              <th class="label-cell">${locale.translate('loan.dashboard.carLoanTag')}</th>
              <th class="">${locale.translate('loan.dashboard.borrower')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.startDate')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.endDate')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.daysToBorrow')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.totalToPay')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.discounts')}</th>
              <th class="medium-only">${locale.translate('general.status')}</th>
              <th class="">${locale.translate('general.options')}</th>
            </tr>
          </thead>
          <tbody>
          ${carLender.map((item) => $h`
            <tr>
              <td class="label-cell">${item.CarLoanTag}</td>
              <td class="">${item.BorrowerName}</td>
              <td class="numeric-cell">${item.CarLoanStartDate}</td>
              <td class="numeric-cell">${item.CarLoanEndDate}</td>
              <td class="numeric-cell">${item.DaysToBorrow}</td>
              <td class="numeric-cell">${item.TotalToPay}</td>
              <td class="numeric-cell">${item.Discounts}</td>
              <td class="medium-only">${locale.translate(`loan.statusLabel.${item.CarLoanStatusId}`)}</td>
              <td class="">
                <a href="#" @click="${continueToLoan}" data-car-id="${item.CarId}" data-car-loan-id="${item.CarLoanId}">
                  <i class="icon material-symbols-outlined">resume</i>
                </a>
              </td>
            </tr>
          `)}
          </tbody>
        </table>
      </div>
      `}
      <br/>
      ${carBorrower.length > 0 && $h`
      <div class="block-title">${locale.translate('loan.borrows')}</div>
      <div class="data-table">
        <table>
          <thead>
            <tr>
              <th class="label-cell">${locale.translate('loan.dashboard.carLoanTag')}</th>
              <th class="">${locale.translate('loan.dashboard.lender')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.startDate')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.endDate')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.daysToBorrow')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.totalToPay')}</th>
              <th class="numeric-cell">${locale.translate('loan.dashboard.discounts')}</th>
              <th class="medium-only">${locale.translate('general.status')}</th>
              <th class="">${locale.translate('general.options')}</th>
            </tr>
          </thead>
          <tbody>
          ${carBorrower.map((item) => $h`
            <tr>
              <td class="label-cell">${item.CarLoanTag}</td>
              <td class="">${item.LenderName}</td>
              <td class="numeric-cell">${item.CarLoanStartDate}</td>
              <td class="numeric-cell">${item.CarLoanEndDate}</td>
              <td class="numeric-cell">${item.DaysToBorrow}</td>
              <td class="numeric-cell">${item.TotalToPay}</td>
              <td class="numeric-cell">${item.Discounts}</td>
              <td class="medium-only">${locale.translate(`loan.statusLabel.${item.CarLoanStatusId}`)}</td>
              <td class="">
                <a href="#" @click="${continueToLoan}" data-car-id="${item.CarId}" data-car-loan-id="${item.CarLoanId}">
                  <i class="icon material-symbols-outlined">resume</i>
                </a>
              </td>
            </tr>
          `)}
          </tbody>
        </table>
      </div>
      `}
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = 'bcd00672a8';
export default framework7Component;